var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportlinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 14H6V6H8.66667V7.33333C8.9474 6.97618 9.30369 6.68558 9.70998 6.48237C10.1163 6.27917 10.5625 6.1684 11.0167 6.158C11.8109 6.16241 12.571 6.48162 13.1303 7.04562C13.6895 7.60963 14.0023 8.3724 14 9.16667V14H11.3333V9.5C11.2818 9.13971 11.1018 8.81018 10.8265 8.57205C10.5513 8.33392 10.1993 8.20322 9.83533 8.204C9.67244 8.20915 9.51226 8.24715 9.36442 8.31573C9.21657 8.38431 9.0841 8.48205 8.97496 8.60308C8.86582 8.72411 8.78225 8.86595 8.72927 9.02008C8.6763 9.1742 8.655 9.33744 8.66667 9.5V14ZM4.66667 14H2V6H4.66667V14ZM3.33333 4.66667C2.97971 4.66667 2.64057 4.52619 2.39052 4.27614C2.14048 4.02609 2 3.68696 2 3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2C3.68696 2 4.02609 2.14048 4.27614 2.39052C4.52619 2.64057 4.66667 2.97971 4.66667 3.33333C4.66667 3.68696 4.52619 4.02609 4.27614 4.27614C4.02609 4.52619 3.68696 4.66667 3.33333 4.66667Z",
    fill: "#898EA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportlinkedin);
export default __webpack_public_path__ + "static/media/support.linkedin.a12a657dd93c81d5531ccbb66500136d.svg";
export { ForwardRef as ReactComponent };